import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "security-app/components/common/Modal";
import { PaginationProvider } from "common/contexts";
import List from "./List";
const SendNotificationModal = ({ onConfirm, closeModal, confirmDisabled, show = true }) => {
  const { t } = useTranslation("enterprise_security_events");
  const [notificationId, setNotificationId] = useState("");
  useEffect(() => {
    setNotificationId("");
  }, [show]);
  const _onConfirm = useCallback(() => onConfirm(notificationId), [notificationId, onConfirm]);
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show,
      onCancel: closeModal,
      onConfirm: _onConfirm,
      confirmDisabled,
      title: t("send_notification_modal.title")
    },
    /* @__PURE__ */ React.createElement(PaginationProvider, null, /* @__PURE__ */ React.createElement(List, { notificationId, setNotificationId }))
  );
};
export default SendNotificationModal;
